import queryString from "query-string";
import { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { titleCase } from "change-case-all";
import { MdViewColumn } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, IconButton, Menu, Tooltip, Typography } from "@mui/material";

import { useAxios } from "../../../hooks";
import { colors } from "../../css components/Style";
import { CancelButton } from "../../css components/Button";
import TableStats from "./analytic table components/Table";
import { Loader, PageHeader, Paper } from "../../../components";
import SummaryDialog from "../create campaign components/campaign form components/SummaryDialog";
import DropDownMenu from "./analytic table components/DropdownButton";

// ✅ Styled Components
const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    height: 200px;
    &:hover {
      box-shadow: none;
    }
  }
`;

export default function CampaignAnalytics() {
  const axios = useAxios();
  const navigate = useNavigate();
  const { campaignID } = useParams();

  const [fields, setFields] = useState({});
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [summaryPopUp, setSummaryPopUp] = useState({ state: false });
  const [analyticData, setAnalyticData] = useState({ summary: [], stats: [] });

  const campaignName = queryString.parse(window.location.search)?.campaignName;

  useEffect(() => {
    axios({
      url: "/get/delivery/channel/summary/" + campaignID,
    }).then((response) => {
      if (response.status) {
        let field = {};
        setAnalyticData({
          stats: [
            {
              channel_name: "Meta",
              stats_data: [
                {
                  _id: "9e1a8b35d6c44bbb96b2b446fd2bf2fe",
                  impressions: "73090",
                  clicks: "38",
                  spend: "172.69",
                  campaign_name: "Awareness - Insurance",
                  reach: "66832",
                  cpm: "2.362704",
                  cpc: "4.544474",
                  date_start: "2024-12-27",
                  date_stop: "2025-01-25",
                  campaign_id: "6573222567907",
                  audience_id: "6625380738707",
                  objective: "OUTCOME_AWARENESS",
                  status: "ACTIVE",
                  channel_id: "3",
                  created_at: 1737963325.032908,
                },
              ],
            },
          ],
          summary: response?.data?.Summary?.channels || [],
        });

        let stats = [
          {
            channel_name: "Meta",
            stats_data: [
              {
                _id: "9e1a8b35d6c44bbb96b2b446fd2bf2fe",
                impressions: "73090",
                clicks: "38",
                spend: "172.69",
                campaign_name: "Awareness - Insurance",
                reach: "66832",
                cpm: "2.362704",
                cpc: "4.544474",
                date_start: "2024-12-27",
                date_stop: "2025-01-25",
                campaign_id: "6573222567907",
                audience_id: "6625380738707",
                objective: "OUTCOME_AWARENESS",
                status: "ACTIVE",
                channel_id: "3",
                created_at: 1737963325.032908,
              },
            ],
          },
        ];

        if (stats?.length > 0) {
          for (let stat of stats) {
            stat.stats_data.map((s) => {
              Object.keys(s).forEach((key, index) => {
                if (field[stat.channel_name]) {
                  if (!field[stat.channel_name].some((ch) => ch.name === key)) {
                    field[stat.channel_name].push({
                      name: key,
                      display: index > 5 ? false : true,
                    });
                  }
                } else {
                  field = {
                    ...field,
                    [stat.channel_name]: [{ name: key, display: true }],
                  };
                }
              });
            });
          }
        }

        setFields(field);
        setAnalyticData({
          stats: stats,
          summary: response?.data?.Summary?.channels || [],
        });
      }
    });
  }, [axios, campaignID]);

  return (
    <Loader>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <PageHeader
            title="Campaign Analytics"
            pageName="Campaign Analytics & Summary"
            pageHeader={campaignName}
            buttons={[
              <CancelButton variant="outlined" onClick={() => navigate(-1)}>
                Back
              </CancelButton>,
            ]}
          />
        </Grid>

        <SummaryDialog
          summary={analyticData?.summary}
          campaignID={campaignID}
          summaryPopUp={summaryPopUp}
          setSummaryPopUp={setSummaryPopUp}
        />

        <Typography variant="h5" sx={{ mt: 4, color: colors.sideBarColor }}>
          Channel Analytics
        </Typography>

        {analyticData?.stats?.length === 0 ? (
          <Grid item xs={12} textAlign="center">
            <Typography variant="h5" color={colors.lightGreen}>
              No stats found
            </Typography>
          </Grid>
        ) : (
          analyticData?.stats?.map((analytic, index) => (
            <Grid item xs={12} key={index}>
              <Paper>
                <Grid container>
                  <Grid item xs={10}>
                    <Typography variant="h4" color={colors.iconColor}>
                      {titleCase(analytic?.channel_name?.replace(/_/g, " "))}
                    </Typography>
                  </Grid>

                  <Grid item xs={2} textAlign="right">
                    <Tooltip title="View Column">
                      <>
                        <Icon
                          onClick={(event) => {
                            setMenuAnchor(event.currentTarget);
                          }}
                        >
                          <MdViewColumn />
                        </Icon>

                        <Menu
                          sx={{
                            mt: "15px",
                            "& .MuiPaper-root": {
                              height: "200px",
                              "&:hover": { boxShadow: "none" },
                            },
                          }}
                          open={!!menuAnchor}
                          anchorEl={menuAnchor}
                          onClose={() => setMenuAnchor(null)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          <DropDownMenu
                            setFields={setFields}
                            channel={analytic?.channel_name}
                            fields={fields}
                            setMenuAnchor={setMenuAnchor}
                          />
                        </Menu>
                      </>
                    </Tooltip>
                  </Grid>
                </Grid>

                <Grid item xs={2} style={{ textAlign: "end" }}>
                  <Tooltip title="View Column">
                    <Icon
                      onClick={(event) => {
                        setMenuAnchor(event.currentTarget);
                      }}
                    >
                      <MdViewColumn />
                    </Icon>

                    <StyledMenu
                      style={{ marginTop: "15px" }}
                      open={!!menuAnchor}
                      anchorEl={menuAnchor}
                      onClose={() => setMenuAnchor(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <DropDownMenu
                        setFields={setFields}
                        channel={analytic?.channel_name}
                        fields={fields}
                        setMenuAnchor={setMenuAnchor}
                      />
                    </StyledMenu>
                  </Tooltip>
                </Grid>
                {analytic.stats_data.length > 0 ? (
                  <Grid item xs={12}>
                    <TableStats
                      fields={fields}
                      campaignID={campaignID}
                      data={analytic}
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} textAlign="center">
                    <Typography variant="h5" color={colors.lightGreen}>
                      No stats found for this channel.
                    </Typography>
                  </Grid>
                )}
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Loader>
  );
}
